<template>
  <BaseDialog
    :model-value="modelValue"
    :title="'Cadastrar Plano'"
    :icon="'mdi-file-document-multiple'"
    :loading="loading"
    @update:modelValue="updateDialog"
    @salvar="salvarPlano"
  >
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="plano.nome"
        label="Nome do Plano"
        :rules="[rules.required]"
        required
        prepend-inner-icon="mdi-tag"
        class="mb-3"
      />
      <v-text-field
        v-model.number="plano.valor"
        label="Valor"
        type="number"
        :rules="[rules.required, rules.isNumber]"
        required
        prepend-inner-icon="mdi-currency-brl"
        class="mb-3"
      />
      <v-text-field
        v-model.number="plano.qtd_usuarios"
        label="Qtd. Usuários"
        type="number"
        :rules="[rules.required, rules.isNumber]"
        required
        prepend-inner-icon="mdi-account-multiple"
        class="mb-3"
      />
      <v-text-field
        v-model.number="plano.codproduto"
        label="Código do Produto"
        type="number"
        :rules="[rules.required, rules.isNumber]"
        required
        prepend-inner-icon="mdi-package-variant"
        append-inner-icon="mdi-magnify"
        @click:append-inner="abrirBuscaProduto"
      />
    </v-form>
  </BaseDialog>
  <DialogBusca
    :open="dialogBusca"
    rota-busca="produtos"
    @update:open="dialogBusca = $event"
    @selecionado="selecionarProduto"
    :exibir-lista="true"
  />
</template>

<script>
import { mapActions } from "vuex";
import api from "../services/api";
import rulesMixin from "@/mixins/rulesMixin";
import DialogBusca from "./DialogBusca.vue";
import BaseDialog from "./comum/BaseDialog.vue";

export default {
  mixins: [rulesMixin],
  components: {
    BaseDialog,
    DialogBusca,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    loading: false,
    dialogBusca: false,
    plano: {
      nome: "",
      valor: null,
      qtd_usuarios: null,
      codproduto: null,
    },
  }),
  watch: {
    modelValue(val) {
      if (!val) {
        // Limpa o form ao fechar
        this.plano = {
          nome: "",
          valor: null,
          qtd_usuarios: null,
          codproduto: null,
        };
        this.valid = false;
        if (this.$refs.form) this.$refs.form.resetValidation();
      }
    },
  },
  methods: {
    ...mapActions(["triggerFeedback"]),
    updateDialog(val) {
      this.$emit("update:modelValue", val);
    },
    fecharDialog() {
      this.$emit("update:modelValue", false);
    },
    abrirBuscaProduto() {
      this.dialogBusca = true;
    },
    selecionarProduto(produto) {
      this.plano.codproduto = produto.codproduto;
    },
    async salvarPlano() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      try {
        await api.post("/planos/", this.plano);
        this.triggerFeedback({
          message: "Plano cadastrado com sucesso!",
          color: "success",
          icon: "mdi-check-circle",
        });

        this.fecharDialog();
        this.$emit("plano-cadastrado");
      } catch (error) {
        console.error(error);
        this.triggerFeedback({
          message: "Erro ao cadastrar plano!",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.custom-dialog-card {
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.custom-dialog-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
}
</style>
